import React from "react";
import { Row, Table, Badge } from "reactstrap";
import Pagination from "../../../../../../shared/components/pagination/Pagination";
import * as env from "../../../../../../env";
import * as users from "../../../../../../shared/service/users";

export default class ProfileTeam extends React.Component {
  state = {
    isOpen: false,
    users: [],
    total: 0,
    startIndex: 0,
    endIndex: env.RECORDS_PER_PAGE,
    progress: "",
  };

  pagination = () => {
    return this.state.users.length > env.RECORDS_PER_PAGE ? (
      <div className="audit-trail-footer">
        <Pagination
          items={this.state.users}
          onChangePage={(pagination) => this.setState(pagination)}
          pageSize={env.RECORDS_PER_PAGE}
        />
      </div>
    ) : (
      ""
    );
  };

  componentDidMount() {
    users.getTeam(this.props.id).then((response) => {
      this.setState({
        users: response.data,
        total: response.total,
      });
    });
  }

  render() {
    return (
      <React.Fragment>
        <Row>
          <Table
            className="table--head-accent table--bordered"
            responsive
            hover
          >
            <thead>
              <tr key="userTeamHeaders">
                <th key="name">Name</th>
                <th key="Role">Role</th>
                <th key="Status">Status</th>
              </tr>
            </thead>
            <tbody>
              {this.state.users.map((user, userIndex) =>
                1 ? (
                  <tr key={userIndex}>
                    <td key="name">
                      {user.first_name} {user.last_name}
                      <br />
                      <small>{user.email}</small>
                    </td>
                    <td key="role_name">{user.role_name}</td>
                    <td key="status">
                      {user.status === "accepted" ? (
                        <Badge color="success" className="capitalizeCase ">
                          {user.status}
                        </Badge>
                      ) : (
                        <Badge color="danger" className="capitalizeCase">
                          {user.status}
                        </Badge>
                      )}
                    </td>
                  </tr>
                ) : (
                  ""
                )
              )}
            </tbody>
          </Table>
          {this.pagination()}
          {this.state.progress}
        </Row>
      </React.Fragment>
    );
  }
}
